/*
 * @Description:
 * @Author: ma.cq
 * @Date: 2021-04-25 11:34:21
 * @LastEditors: ma.cq
 * @LastEditTime: 2021-05-14 15:38:08
 */
export const columnMap = {
  0: [
    {
      label: '统计时间段',
      prop: 'time'
    },
    {
      label: '商城订单数（张）',
      prop: 'orderQuantity'
    },
    {
      label: '商城订单总金额',
      prop: 'orderAmount'
    },
    {
      label: '商城发运数量',
      prop: 'orderSendQuantity'
    },
    {
      label: '商城发运总金额',
      prop: 'orderSendAmount'
    }
  ],
  1: [
    {
      label: '统计时间段',
      prop: 'time'
    },
    {
      label: '商城订单数（张）环比增长/下降率',
      prop: 'orderQuantityRatio'

    },
    {
      label: '商城订单总金额环比增长/下降率',
      prop: 'orderAmountRatio'

    },
    {
      label: '商城发运数量环比增长/下降率',
      prop: 'orderSendQuantityRatio'
    },
    {
      label: '商城发运总金额环比增长/下降率',
      prop: 'orderSendAmountRatio'
    }
  ],
  2: [
    {
      label: '统计时间段',
      prop: 'time'
    },
    {
      label: '商城订单数（张）同比增长/下降率',
      prop: 'orderQuantityRatio'

    },
    {
      label: '商城订单总金额同比增长/下降率',
      prop: 'orderAmountRatio'

    },
    {
      label: '商城发运数量同比增长/下降率',
      prop: 'orderSendQuantityRatio'
    },
    {
      label: '商城发运总金额同比增长/下降率',
      prop: 'orderSendAmountRatio'
    }
  ]
}

export const cardDataList = [
  {
    title: '销售数据',
    iconName: 'look'
  },
  {
    title: '环比销售数据',
    iconName: 'bar'
  },
  {
    title: '同比销售数据',
    iconName: 'bar'
  }
]
